'use strict'

import React from 'react';
import superagent from 'superagent';

import {ApprovableReport,TableRow} from '../brief/ProjectBrief.jsx';
import {Report} from '../Report.jsx';
import FormattedContent from '../components/FormattedContent.jsx';
import AreaForm from '../components/AreaForm.jsx'
import sendCommand from '../../app/utils/sendCommand.js';
import Slides from '../components/Slides.jsx';
import {FormattedSlide} from '../components/Slides.jsx';
import ReleaseImplementationMethod from '../product/ReleaseImplementationMethod.jsx';
import ReleaseFlow from '../product/ReleaseFlow.jsx';
import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]).loadVariants([
    require('./labels/product/english#productPlan.js'),
    require('./labels/product/norwegian#productPlan.js')
  ]);

import {formatTimeTolerance} from './Plan.jsx';

import setupStageBudget from './setupStageBudget.js';

function formatBudgetNumber(value,context) {
  return value!==undefined && value!==null ? value.replace(/\B(?=(\d{3})+(?!\d))/g, context.language!=="norwegian" ? "," : " ") : "";
}

class Budget extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).stageCost.fields.budget.columns;
    let headings=translations.getTranslation(this.props).general;
    return this.props.budget!==undefined ? (
      <div>
        <table style={{fontSize:"inherit", borderCollapse:"collapse", border: "solid 1px lightgrey", width:"100%"}}>
          <thead>
            <tr style={{backgroundColor: "#e9e7e6"}}>
              {Object.keys(labels).map((key,index)=>(
                <th key={index} style={{border: "solid lightgrey 1px", padding:5}}>
                  {labels[key].title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.props.budget.map((item,rowIndex)=>hasBudgetElement(item) ? (
              <tr key={item.id} style={{fontWeight:rowIndex+1===this.props.budget.length ? "bold" : "normal"}}>
                {Object.keys(labels).map((key,index)=>(
                  <td key={index} style={{border: "solid lightgrey 1px", padding:5, textAlign:(key==="cost" || key==="tolerance") ? "right" : undefined}}>
                    {key==="element" ? headings[item.id] : formatBudgetNumber(item[key],this.props)}
                  </td>
                ))}
            </tr>
          ) : null)}
          </tbody>
        </table>
        {this.props.project.currency!==undefined ? (
          <div style={{paddingTop:10}}>
            <i>{headings.stagePlanCurrency.replace("{currency}",this.props.project.currency)}</i>
          </div>
        ) : null}
      </div>
    ) : null;
  }
}

class Schedule extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.stagePlan;
    return (
      <div>
        <span>{labels.startDate}: {this.props.stage.time.start}</span>
        <span style={{paddingLeft:20}}>{labels.endDate}: {this.props.stage.time.end}</span>
        {this.props.stage.time.tolerance!==undefined
          && this.props.stage.time.tolerance!==null
          || this.props.stage.timeComments!==undefined
          && this.props.stage.timeComments!==null ? (
          <div>
            {labels.timeTolerance}
            <span> </span>
            {formatTimeTolerance(this.props.stage.time,this.props)}
            {this.props.stage.timeComments!==undefined ?(
              <div style={{paddingTop: 10}}>
                <FormattedContent value={this.props.stage.timeComments}/>
              </div>
            ) : null}
          </div>
        ) : null }
      </div>
    );
  }
}

function hasFieldValue(field) {
  let hasFieldValue=field!==undefined && field!==null && field.trim().length!==0;
  return hasFieldValue;
}

function hasBudgetElement(element) {
  let hasBudgetElement=element!==undefined
    && element!==null
    && (
      hasFieldValue(element.cost)
      || hasFieldValue(element.tolerance)
      || hasFieldValue(element.comment)
    );
  return hasBudgetElement;
}

function hasBudget(budget) {
  var hasRows=[];
  if (budget!==undefined && budget!==null) {
    hasRows=hasRows.concat(budget.filter(elementRow=>hasBudgetElement(elementRow)).map(elementRow=>elementRow.id));
  }
  return budget!==undefined && budget!==null && hasRows.length>0;
}


class StagePlanSlides  extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let plan1Comments=this.props.stage.planVersion===1 && this.props.stage.comments!==undefined
      && this.props.stage.comments!==this.props.stage.description
      ? this.props.stage.comments
      : null;
    let budget=this.props.stage.budget!==undefined && this.props.stage.planVersion>1 ? this.props.stage.budget : setupStageBudget(this.props.stage);
    var date=this.props.date!==undefined ? new Date(Date.parse(this.props.date)).toISOString().slice(0,10) : new Date().toISOString().slice(0,10);
    let nameAndDate=(this.props.project!==undefined ? this.props.project.name+" - " : "")+date;

    let stagePlanSlides=[<FormattedSlide
                          label={this.props.title}
                          content={nameAndDate}
                          slideType="title"
                        />,
                        <FormattedSlide
                          label={labels.stageDescription.fields.description.title}
                          content={this.props.stage.description}
                        />,
                        <FormattedSlide
                          label={labels.stageDescription.fields.prerequisite.title}
                          content={this.props.stage.prerequisite}
                        />,
                        <FormattedSlide
                          label={labels.stageContext.fields.externalDependencies.title}
                          content={this.props.stage.externalDependencies}
                        />,
                        <FormattedSlide
                          label={labels.stageContext.fields.assumptions.title}
                          content={this.props.stage.assumptions}
                        />,
                        <FormattedSlide
                          label={labels.stageContext.fields.stageApproach.title}
                          content={this.props.stage.stageApproach}
                        />,
                        <FormattedSlide
                          label={labels.stageContext.fields.lessonsIncorporated.title}
                          content={this.props.stage.lessonsIncorporated}
                        />,
                        <FormattedSlide
                          label={labels.stageContext.fields.monitorAndControl.title}
                          content={this.props.stage.monitorAndControl}
                        />,
                        <FormattedSlide
                          label={labels.general.stagePlan.budget}
                          content={hasBudget(budget)? <Budget {...this.props} budget={budget}/> : undefined}
                        />,
                        <FormattedSlide
                          label={labels.general.stagePlan.schedule}
                          content={<Schedule {...this.props} stage={this.props.stage}/>}
                        />,
                        <FormattedSlide
                          label={labels.stageScheduleScope.fields.scheduleComments.title}
                          content={this.props.stage.scheduleComments}/> ];
  let stagePlanSlideTitles=[labels.stageDescription.frontPage,
                      labels.stageDescription.fields.description.title,
                      labels.stageDescription.fields.prerequisite.title,
                      labels.stageContext.fields.externalDependencies.title,
                      labels.stageContext.fields.assumptions.title,
                      labels.stageContext.fields.stageApproach.title,
                      labels.stageContext.fields.lessonsIncorporated.title,
                      labels.stageContext.fields.monitorAndControl.title,
                      labels.general.stagePlan.budget,
                      labels.general.stagePlan.schedule,
                      labels.stageScheduleScope.fields.scheduleComments.title];
    return (
      <div>
        <Slides slides={stagePlanSlides} slideTitles={stagePlanSlideTitles}/>
      </div>
    );
  }
}

export class StagePlanContent extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let plan1Comments=this.props.stage.planVersion===1 && this.props.stage.comments!==undefined
      && this.props.stage.comments!==this.props.stage.description
      ? this.props.stage.comments
      : undefined;
    let budget=this.props.stage.budget!==undefined && this.props.stage.planVersion>1 ? this.props.stage.budget : setupStageBudget(this.props.stage);
    return !this.props.presentationMode ? (
      <div style={{paddingTop:5}}>
          <table className="briefTable" style={{fontSize:"inherit", borderCollapse: "collapse"}} cellPadding="0" cellSpacing="0">
            <tbody>
              <TableRow
                label={labels.stageDescription.fields.description.title}
                content={this.props.stage.description}
              />
              {this.props.project.isProduct===true || this.props.stage.isRelease===true ? (
                <TableRow
                  label={labels.stageDescription.fields.method.title}
                  content={labels.stageDescription.fields.method.values[this.props.stage.method]}
                />
              ) : null}
              <TableRow
                label={labels.stageDescription.fields.prerequisite.title}
                content={this.props.stage.prerequisite}
              />
              <TableRow
                label={labels.stageContext.fields.externalDependencies.title}
                content={this.props.stage.externalDependencies}
              />
              <TableRow
                label={labels.stageContext.fields.assumptions.title}
                content={this.props.stage.assumptions}
              />
              <TableRow
                label={labels.stageContext.fields.stageApproach.title}
                content={this.props.stage.stageApproach}
              />
              <TableRow
                label={labels.stageContext.fields.lessonsIncorporated.title}
                content={this.props.stage.lessonsIncorporated}
              />
              <TableRow
                label={labels.stageContext.fields.monitorAndControl.title}
                content={this.props.stage.monitorAndControl}
              />
              <TableRow
                label={labels.general.stagePlan.budget}
                content={hasBudget(budget)? <Budget {...this.props} budget={budget}/> : undefined}
              />
              <TableRow
                label={labels.general.stagePlan.schedule}
                content={<Schedule {...this.props} stage={this.props.stage}/>}
              />
          </tbody>
        </table>
        {plan1Comments!==undefined ? (
          <div style={{paddingTop: 15}}>
            <i><FormattedContent value={plan1Comments}/></i>
          </div>
        ) : null}
        <h3>{labels.stageScheduleScope.fields.scheduleComments.title}</h3>
        <FormattedContent value={this.props.stage.scheduleComments}/>
      </div>
    ) : (
      <div>
        <StagePlanSlides {...this.props}/>
      </div>
    );
  }
}

class BackMenu extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.stageMenu;
    return (
      <div style={{paddingBottom:20}}>
        <a href={"../../"+(this.props.project.isRelease===true ? "" : "plan?show=approach&planVersion=2#schedule")} onClick={this.props.onCancel}>&lt;- {labels.back}</a>
      </div>
    );
  }
}

class MoveStageAction extends React.Component {
  constructor(props) {
    super(props);
    this.state={inAction:false};
  }

  componentWillReceiveProps(props) {
    this.setState({inAction:false});
  }

  toggleView(event) {
    event.preventDefault();
    this.setState({inAction:!this.state.inAction});
  }

  moveStage(event) {
    event.preventDefault();
    if (this.props.onMoveStage!==undefined) {
      this.props.onMoveStage(this.props.stage.id, event.target.value);
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).general.stageMenu;
    return (this.props.projectType===undefined || this.props.projectType.phases===undefined) ? (
        null //<div>No phases for project type</div>
      ) : this.state.inAction ? (
        <div>
          <b>{labels.move}</b>
          <div style={{paddingLeft: 10}}>
            {labels.selectPhase}:
            <div>
              <select value={this.props.stage.phase!==undefined ? this.props.stage.phase.id : undefined} onChange={this.moveStage.bind(this)}>
                {this.props.stage.phase===undefined || this.props.stage.phase.id===undefined ? (
                  <option value="">- {labels.noPhase} - </option>
                ) : null}
                {this.props.projectType.phases.map(phase=>(
                  <option key={phase.id} value={phase.id}>{phase.text}</option>
                ))}
              </select>
            </div>
            <div style={{paddingTop:10}}>
              <a onClick={this.toggleView.bind(this)} href="#">{labels.cancelMove}</a>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <a href="#" onClick={this.toggleView.bind(this)}>{labels.move}</a>
        </div>
      )
  }
}

class ProjectClosure extends React.Component {
  constructor(props) {
    super(props);
    this.state={displayClosure: false};
  }

  selectClosure(event) {
    event.preventDefault();
    this.setState({displayClosure: !this.state.displayClosure});
  }

  confirmClosure(event) {
    event.preventDefault();
    if (this.props.onConfirm!==undefined) {
      this.props.onConfirm();//{type:event.target.elements.closure.value});
    }
    this.setState({displayClosure: false});
  }

  render() {
    let labels=translations.getTranslation(this.props).general.stageMenu;
    return this.state.displayClosure ? (
      <div style={{paddingTop: 15}}>
        <form onSubmit={this.confirmClosure.bind(this)}>
        <div>
          <b>Project Closure</b>
        </div>
        <div style={{paddingTop:5}}>
          Select closure approach:
        </div>
        <div>
          <input name="closure" type="radio" value="planned" id="plannedClosure"/> <label htmlFor="plannedClosure">Planned closure</label>
        </div>
        <div>
          <input name="closure" type="radio" value="unplanned" id="prematureClosure"/> <label htmlFor="prematureClosure">Premature closure</label>
        </div>
        <div style={{paddingTop:10}}>
          <input className="save" type="submit" value="Prepare closure"/>
          <a onClick={this.selectClosure.bind(this)} href="#">Cancel</a>
        </div>
      </form>
      </div>
    ) : (
      <div style={{paddingTop:10}}>
        <a onClick={this.confirmClosure.bind(this)} href="#">{labels.prepareClosure}</a>
      </div>
    );
  }
}

class StageTransition extends React.Component {
  constructor(props) {
    super(props);
    let nextStage=this.findNextStage(props.project);
    let pendingApproval=this.props.project.requestedStageTransition!==undefined
        && this.props.project.requestedStageTransition.stage!==undefined
        && this.props.project.requestedStageTransition.stage.id===this.props.stage.id;
    let isNextStage=nextStage!==undefined && nextStage.id===this.props.stage.id;
    let isCurrentStage=this.props.project.currentStage!==undefined && this.props.project.currentStage.id===this.props.stage.id;
    this.state={
      status: pendingApproval ? "pendingApproval"
        : isNextStage ? "nextStage"
        : isCurrentStage ? "currentStage"
        : undefined,
      lastStage: isCurrentStage && nextStage===undefined
     }
  }

  findNextStage(project) {
    var nextStage=undefined;
    if (project.stages!==undefined && project.stages.length>0)  {
      var currentIndex=-1;
      if (project.currentStage!==undefined) {
        project.stages.forEach((stage,index) => {
          if (stage.id===project.currentStage.id) {
            currentIndex=index;
          }
        });
      }
      if (currentIndex+1<project.stages.length) {
        nextStage=project.stages[currentIndex+1];
      } else {
        var closeProject=true;
      }
    }
    return nextStage;
  }

  requestStageApproval() {
    let action="request";
    superagent
      .get("/projects/"+this.props.project.id+"/"+action+"/"+this.props.stage.id+"?redirect=false")
      .then(response=>{
        this.setState({status:"pendingApproval"})
        if (this.props.onUpdate!==undefined) {
          this.props.onUpdate(JSON.parse(response.text).project);
        }
      })
      .catch(error=>{
        console.log("Received error", error);
        alert("An error occured, please try again");
      })
  }

  approveStage() {
    let action="approve";
    superagent
      .get("/projects/"+this.props.project.id+"/"+action+"/"+this.props.stage.id+"?redirect=false")
      .then(response=>{
        this.setState({status:"currentStage"});
        if (this.props.onUpdate!==undefined) {
          this.props.onUpdate(JSON.parse(response.text).project);
        }
      })
      .catch(error=>{
        console.log("Received error", error);
        alert("An error occured, please try again");
      })
  }

  retractStageApproval() {
    let action="retract";
    superagent
      .get("/projects/"+this.props.project.id+"/"+action+"/"+this.props.stage.id+"?redirect=false")
      .then(response=>{
        this.setState({status:"nextStage"});
        if (this.props.onUpdate!==undefined) {
          this.props.onUpdate(JSON.parse(response.text).project);
        }
      })
      .catch(error=>{
        console.log("Received error", error);
        alert("An error occured, please try again");
      })
  }

  prepareClosure(details) {
    sendCommand({type:"prepareProjectClosure", project: {id: this.props.project.id}})
      .then(()=>window.location="/projects/"+this.props.project.id)
      .catch(error=>{
        console.log("[ERROR] not able to prepare closure, got ",error);
        alert("An error occured, please try again");
      });
  }

  render() {
    let labels=translations.getTranslation(this.props).general.stageMenu;
    let status=this.state.status;
    return status==="pendingApproval" ? (
      <div id="nextStageWithPendingRequest">
        <div><a onClick={this.approveStage.bind(this)} href="#">{labels.approveStage}</a></div>
        <div><a onClick={this.retractStageApproval.bind(this)} href="#">{labels.retractRequest}</a></div>
      </div>
    ) : status==="nextStage" ? (
      <div id="nextStageWithoutPendingRequest">
        <a onClick={this.requestStageApproval.bind(this)} href="#">{labels.requestApproval}</a>
      </div>
    ) : status==="currentStage" ? (
      <div id="currentStage">
        {this.props.report===undefined && !this.props.project.isClosing ? (
          <div><a href={"/projects/"+this.props.project.id+"/highlight?endStage=true"}>{labels.endStageReport}</a></div>
        ) : null}
        {this.props.closureEnabled===true && !this.props.project.isClosing ? (
          <ProjectClosure {...this.props} onConfirm={this.prepareClosure.bind(this)}/>
        ) : null}
        {this.props.stage.approved===undefined ? (
          <div style={{color:"#212121", marginTop:10, fontFamily:"Lato", backgroundColor:"#FFEADB", padding:5}}>
            {labels.changesToApprovedStage}
          </div>
        ) : null}
      </div>
    ) : (
      <div id="notCurrentNorNextStage">
      </div>
    )
  }
}

class RaiseException extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).general.stageMenu;
    let isCurrentStage=this.props.project.currentStage!==undefined && this.props.project.currentStage.id===this.props.stage.id;
    return isCurrentStage ? (
      <div style={{display:"normal", color:"grey"}}><a href={"/projects/"+this.props.project.id+"/change?show=approach"}>{labels.raiseException}</a></div>
    ) : null;

  }
}

class ReportActions extends React.Component {

  edit(event) {
    if (this.props.onEdit) {
      this.props.onEdit(event)
    } else if (this.props.disableEdit==="reloadPlan"){
      event.preventDefault();
      window.location=(this.props.stage.isRelease ? "/releases/"+this.props.stage.id : "/projects/"+this.props.project.id)+"/plan?editStage="+this.props.stage.id;
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).general.stageMenu;
    return (
      <div style={{paddingTop: 15}}>
        <b>{labels.stageActions}</b>
        <div style={{paddingLeft:10}}>
          {this.props.deleteEnabled || this.props.disableEdit!==true && this.props.stage.historic!==true ? (
            <div>
              <a href="#" onClick={this.edit.bind(this)}>{labels.edit}</a>
            </div>
          ) : null}
          {this.props.hideActuals===false && this.props.stage.historic===true || this.props.project.isClosing ? (
            <div>
              <a onClick={this.props.onActuals} href="#">{labels.registerActuals}</a>
            </div>
          ) : null}
          <MoveStageAction {...this.props}/>
          {this.props.project.isProduct===true || this.props.stage.isRelease===true ? (
            <ReleaseFlow {...this.props} release={this.props.stage}/>
          ) : (
            <StageTransition {...this.props}/>
          )}
        </div>
        {this.props.report!==undefined ? (
          <div style={{paddingTop:15}}>
            <b>End Stage Report</b>
            <div style={{paddingLeft:10}}>
              <a href={"/projects/"+this.props.project.id+"/reports?id="+this.props.report.id+"&showEndStage=true"}>View in archive</a>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
}

function formatNumber(value,column,context) {
  return column==="hours" || column==="expences" || column==="investments" || column==="sum" || column==="costTolerance" || column==="cost" || column==="tolerance"
    ? <div style={{textAlign: "right"}}>{value!==undefined && value!==null ? value.replace(/\B(?=(\d{3})+(?!\d))/g, context.language!=="norwegian" ? "," : " ") : ""}</div>
    : <FormattedContent value={value}/>;
}

class Actuals extends React.Component {
  constructor(props) {
    super(props);
    let labels=translations.getTranslation(props).general;
    this.state={
      actuals: {
        id: "actuals",
        period: {
          from: props.stage.time.start!==null && props.stage.time.start!==undefined && props.stage.time.start.length>0 ? props.stage.time.start : undefined,
          to: props.stage.time.end!==null && props.stage.time.end!==undefined && props.stage.time.end.trim().length>0 ? props.stage.time.end : undefined
        },
        cost: setupStageBudget(props.stage,labels).map(item=>Object.assign({},item,{_format:formatNumber})),
      }
    };
  }

  onUpdate(event) {
    if (this.props.onUpdate!==undefined) {
      this.props.onUpdate(this.state.actuals);
    }
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      this.setState({
        actuals:Object.assign({},this.state.actuals,{[event.target.name]:event.target.value})
      })
    };

  }

  render() {
    let form=[{
      name: "actuals",
      fields: [
        { name: "period", type: "period" },
        { name: "cost", type:"table",
          options: {
            summaryRow: true
          },
          columns: [
            { name: "element" },
            { name: "cost", editable: "true" },
            { name: "comment", editable: "true" }
          ]
        }
      ]
    }];
    let areas=translations.createTranslatedForm(form,this.props.language,this.props.variant);
    let labels=translations.getTranslation(this.props).general
    return (
      <div style={{minWidth:800}}>
        <AreaForm
          {...this.props}
          display="tab"
          areas={areas}
          item={this.state.actuals}
          onCancel={this.props.onCancel}
          onUpdate={this.onUpdate.bind(this)}
          label={labels.actuals}
          handleFieldChange={this.handleFieldChange.bind(this)}
          modified={true}
          selected={0}
        />
      <div style={{paddingTop:50, borderBottom:"solid 3px grey"}}>
        </div>
      </div>
    );
  }
}

export default class StagePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      stage: props.stage,
      registerActuals:false
    };
  }

  componentWillReceiveProps(props) {
    this.setState({stage:props.stage});
  }

  toggleActuals(event) {
    this.setState({registerActuals:!this.state.registerActuals});
  }

  updateActuals(actuals) {
    var command={
      type:"assignActuals",
      period: actuals.period,
      cost: actuals.cost.map(item=>({id:item.id, cost: item.cost, comment: item.comment}))
    };
    if (this.props.project.isRelease===true) {
      command=Object.assign({},command,{
        product: {id: this.props.stage.product.id},
        release: {id: this.props.stage.id}
      });
    } else if (this.props.project.isProduct===true) {
      command=Object.assign({},command,{
        product: {id: this.props.project.id},
        release: {id: this.props.stage.id}
      });
    } else {
      command=Object.assign({},command,{
        project: {id: this.props.project.id},
        stage: {id: this.props.stage.id}
      });
    }
    sendCommand(command)
      .then(response=>{
        this.setState({stage: response.stage, registerActuals:false});
        if (this.props.onUpdateStage!==undefined)  {
          this.props.onUpdateStage(response.stage);
        }
      })
      .catch(error=>{
        console.log("[ERROR] Not able to save actuals, got ",error);
        alert("An error occured, please try again");
      });
  }

  makeActive(event) {
    event.preventDefault();
    console.log("Show implementation selector");
    this.setState({implementationMethodVisible: true});
  }

  setImplementationMethod(method,projectId) {
    sendCommand({
      type:"startReleaseWithMethod",
      product: {id: this.props.project.id},
      release: {id: this.props.stage.id},
      method:method,
      implementationProject: method==="project" ? { id: projectId} : undefined
    })
      .then(response=>{
        this.setState({implementationMethodVisible:false, stage: response.release});
        if (this.props.onUpdateStage!==undefined) {
          this.props.onUpdateStage(response.release);
        }
      })
      .catch(error=>{
        console.log("Got error", error);
        alert("An error occured, please try again");
      });
  }

  completeRelease() {
    sendCommand({type: "completeRelease", release: {id: this.props.stage.id}, product: {id: this.props.stage.product.id}})
      .then(response=>{
        this.setState({stage: response.release});
        if (this.props.onUpdateStage!==undefined) {
          this.props.onUpdateStage(response.release);
        }
      })
      .catch(error=>{
        console.log("[ERROR] Not able to complete release, got "+error);
        alert("An error occured, please try again")
      });
  }

  render() {
    var date=this.state.stage.active===true || this.state.stage.historic===true && this.state.stage.history!==undefined
      ? new Date(this.state.stage.history.slice(-1)[0].approved.date).toISOString().slice(0,10)
      : new Date().toISOString().slice(0,10);
    let selected=this.props.selected!==undefined
      && this.props.selected.length>0
      && this.state.stage.history!==undefined
        ? this.state.stage.history.filter(item=>item.version==this.props.selected)[0]
        : this.state.stage
    let nameAndDate=(this.props.project!==undefined ? this.props.project.name+" - " : "")+date;
    let type=this.props.pid!==undefined ? this.props.pid.type : undefined;
    let labels=translations.getTranslation(this.props);
    return this.state.implementationMethodVisible ? (
      <div style={{textAlign:"center"}}>
        <div style={{display:"inline-block", textAlign:"left", maxWidth:1016}}>
          <ReleaseImplementationMethod
            {...this.props}
            product={this.props.project}
            onCancel={(event)=>this.setState({implementationMethodVisible:false})}
            onChange={this.setImplementationMethod.bind(this)}
          />
        </div>
      </div>
    ) : (
      <div>
      <ApprovableReport
        {...this.props}
        menuTopItems={<BackMenu {...this.props}/>}
        hideReportDisplayMenu={false}
        definedTableView={false}
        disabledActions={true}
        showCurrent={true}
        menuReportActions={<ReportActions {...this.props} stage={selected} report={this.props.stage.report} hideActuals={this.state.registerActuals} onActuals={this.toggleActuals.bind(this)} activate={this.makeActive.bind(this)} onComplete={this.completeRelease.bind(this)}/>}
        title={labels.general.stagePlan.title+" - "+this.props.stage.name} //labels.pid.title}
        date={selected.approved!==undefined ? selected.approved.date : new Date()}
        type={selected.approved===undefined && this.props.project.isRelease!==true && this.props.project.isProduct!==true ? "preview" : ""}
        selected={Object.assign({},selected,{
          type: selected.approved===undefined ? "preview" : ""
        })}
        hasPreview={this.props.stage.version===undefined}
        current={Object.assign({},this.state.stage, {
          history: this.state.stage.history!==undefined
            ? this.state.stage.history.map(item=>
                Object.assign({},item,{date:item.approved.date
              }))
            : undefined

        })}
//        report="StagePlan"
//        approveLabel={labels.approval.approve}
      >
        {this.state.stage.actuals===true ? (
          <div style={{marginTop:10, border: "solid 1px grey", padding:5, textAlign:"center", backgroundColor:"lightgrey", color:"black", fontWeight: "bold"}}>
            {labels.general.showingActuals}
          </div>
        ) : null}
        {this.state.registerActuals ? (
          <Actuals
            {...this.props}
            stage={this.state.stage}
            onCancel={this.toggleActuals.bind(this)}
            onUpdate={this.updateActuals.bind(this)}
          />
        ) : null }
            <StagePlanContent {...this.props} stage={selected} title={labels.general.stagePlan.title+" - "+this.props.stage.name} date={selected.approved!==undefined ? selected.approved.date : new Date()}/>
            {!this.props.presentationMode && selected.approved!==undefined && selected.approved.exception!==undefined ? (
              <div style={{paddingTop:30}}>
                Version 1.{selected.version}: Automatically approved with approval of exception
                <div style={{paddingLeft:10}}>
                  <FormattedContent value={selected.approved.exception.summary}/>
                </div>
              </div>
            ) : null}
      </ApprovableReport>
      {false && this.state.stage.report!==undefined && this.props.fullPage===undefined ? (
        <div style={{paddingTop:50}}>
          <hr/>
          <div style={{display:"inline-block", float: "right",marginRight: 30, width:250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft:10, paddingBottom: 150}}>
            <div style={{paddingTop:30}}>
              <a href={"/projects/"+this.props.project.id+"/reports?id="+this.state.stage.report.id+"&showEndStage=true"}>View in archive</a>
            </div>
          </div>
          <Report
            {...this.props}
            selected={this.state.stage.report.id}
            showEndStage={true}
          />
        </div>
      ) : null}
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/plan/StagePlan.jsx